// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3Srps","title":"ClientReferral_title__pFUsr","itemText":"ClientReferral_itemText__1qa76"};